module.exports = __webpack_public_path__ + "static/media/google-plus-g.0768d91a.svg";